import { render, staticRenderFns } from "./LightboxResetPwd.vue?vue&type=template&id=73b80faa&"
import script from "./LightboxResetPwd?vue&type=script&lang=ts&"
export * from "./LightboxResetPwd?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports